"use strict";

exports.__esModule = true;
exports.getSiteColor = exports.setColorOpacity = exports.getPresetColor = void 0;

var _lodash = require("lodash");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var throwRequired = function throwRequired(name) {
  throw new Error(name + " is required");
};

var getStyleColor = function getStyleColor(appSettings, wixParam) {
  return (0, _lodash.get)(appSettings, "style.colors[" + wixParam + "].value");
};

var getPresetColor = function getPresetColor(appSettings, presetName) {
  return (0, _lodash.get)((0, _lodash.find)(appSettings.colorPresets, function (_ref) {
    var reference = _ref.reference;
    return reference === presetName;
  }), 'value');
};

exports.getPresetColor = getPresetColor;

var setColorOpacity = function setColorOpacity(color, alpha) {
  if (alpha === void 0) {
    alpha = 1;
  }

  return (0, _tinycolor["default"])(color).setAlpha(alpha).toRgbString();
};

exports.setColorOpacity = setColorOpacity;

var getSiteColor = function getSiteColor(appSettings, _ref2) {
  var wixParam = _ref2.wixParam,
      presetFallback = _ref2.presetFallback,
      colorFallback = _ref2.colorFallback,
      _ref2$opacity = _ref2.opacity,
      opacity = _ref2$opacity === void 0 ? undefined : _ref2$opacity;
  if (!wixParam) throwRequired('wixParam');
  if (!presetFallback) throwRequired('presetFallback');
  if (!colorFallback) throwRequired('colorFallback');
  var color = getStyleColor(appSettings, wixParam) || getPresetColor(appSettings, presetFallback) || colorFallback;
  return opacity !== undefined ? setColorOpacity(color, opacity) : (0, _tinycolor["default"])(color).toRgbString();
};

exports.getSiteColor = getSiteColor;